import { ReactNode } from 'react';
import { Stack } from '../../../design-system/stack/stack';

type BankFeedsTableWrapperProps = {
  title: string;
  description?: string;
  children: ReactNode;
};

export const BankFeedsTableWrapper = ({ title, description, children }: BankFeedsTableWrapperProps) => {
  return (
    <Stack space={3} align="stretch">
      <Stack space={1}>
        <h3 className="text-sm leading-6 font-medium tracking-tight text-black">{title}</h3>
        {description && (
          <p className="text-xs leading-[22px] font-normal tracking-tight text-muted-foreground">{description}</p>
        )}
      </Stack>
      <div className="bg-white">{children}</div>
    </Stack>
  );
};
